import React from "react";
import "./DetailPanel.scss";
import { IconButton } from "@mui/material";
import { CloseIcon } from "../icons";
import { ResponseData } from "../../types/response.types";
import RRWebPlayer from "../RRWebPlayer/RRWebPlayer";
import { formatDate } from "../../utils/dateUtils";
import PulseExpandPanel from "../PulseExpandPanel/PulseExpandPanel";

interface DetailPanelProps {
  isOpen: boolean;
  onClose: () => void;
  data?: ResponseData;
}

const DetailPanel: React.FC<DetailPanelProps> = ({ isOpen, onClose, data }) => {
  if (!data) return null;
  console.log("data", data);

  return (
    <div className={`detail-panel ${isOpen ? "open" : ""}`}>
      <div className="panel-header">
        <IconButton className="close-button" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>

      <div className="panel-content">
        <div className="response-info">
          <div className="response-metadata">
            <div className="metadata-row">
              <span className="headline-xs">
                {data.device.userId ? "ID: " + data.device.userId : "Response"}
              </span>
              <span className="body-m">{formatDate(data.createdAt)}</span>
            </div>
          </div>

          <div className="video-player">
            {data.videoUrl.includes(".mp4") ? (
              <video
                key={`video-${data.videoUrl}`}
                src={data.videoUrl}
                controls
                controlsList="nodownload"
                onError={(e) => console.error("Video error:", e)}
                playsInline
                autoPlay
                muted
              >
                <source src={data.videoUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <RRWebPlayer
                key={`rrweb-${data.videoUrl}`}
                events={data.videoUrl}
                width={400}
                height={300}
                autoPlay={true}
                showController={true}
              />
            )}
          </div>

          {/* <div className="panel-feedback-form">
            <span className="label">FEEDBACK FORM</span>

            {data.feedback.responses.map((response, index) => (
              <div key={index} className="form-question">
                <label>{response.question}</label>
                <div className="answer">{response.response}</div>
              </div>
            ))}
          </div> */}
        </div>

        <PulseExpandPanel
          title="Feedback Form"
          defaultExpanded={true}
          className="device-info"
        >
          <div className="device-details">
            {data.feedback.responses.map((response, index) => (
              <div
                key={index}
                className="form-question"
                style={{ marginBottom: "16px" }}
              >
                <label className="text-secondary body-m">
                  {response.question}
                </label>
                <div className="body-l">{response.response}</div>
              </div>
            ))}
          </div>
        </PulseExpandPanel>

        <PulseExpandPanel
          title="Device Info"
          defaultExpanded={false}
          className="device-info"
        >
          <div className="device-details">
            <div className="detail-row">
              <span className="value">{data.device.type}</span>
              <span className="label">DEVICE TYPE</span>
            </div>
            <div className="detail-row">
              <span className="value">{data.device.osType}</span>
              <span className="label">OS TYPE</span>
            </div>
            <div className="detail-row">
              <span className="value">{data.device.osVersion}</span>
              <span className="label">OS VERSION</span>
            </div>
            <div className="detail-row">
              <span className="value">{data.device.userId}</span>
              <span className="label">USER ID</span>
            </div>
          </div>
        </PulseExpandPanel>
      </div>
    </div>
  );
};

export default DetailPanel;
